import { useEffect, useState } from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { SliderNavigation } from './navigation';
import { Card } from './card';
import 'swiper/css';
import s from './index.module.scss';

export const BrandGallery = ({ images }) => {
  const [ready, setReady] = useState(false);
  const [swiperRef, setSwiperRef] = useState(null);
  const [params, setParams] = useState({
    isBeginning: true,
    isEnd: false,
  });

  useEffect(() => {
    if (ready && images.length) {
      setParams({
        isBeginning: true,
        isEnd: !!swiperRef?.isEnd,
      });
    }
  }, [ready, images.length]);

  const onNext = () => {
    swiperRef?.slideNext();
  };

  const onPrev = () => {
    swiperRef?.slidePrev();
  };

  if (!images || !images?.length) return null;

  if (images.length === 1) {
    return <Card image={images[0]} />;
  }

  return (
    <div className={s.wrapper}>
      <div className={s.container}>
        <Swiper
          onAfterInit={() => setReady(true)}
          onSwiper={setSwiperRef}
          spaceBetween={12}
          slidesPerView="auto"
          onSlideChange={() => {
            setParams({
              isBeginning: swiperRef.isBeginning,
              isEnd: swiperRef.isEnd || swiperRef.snapIndex - swiperRef.activeIndex === 1,
            });
          }}
        >
          {images.map(img => (
            <SwiperSlide key={img.id} style={{ width: '290px', height: '180px' }}>
              <Card image={img} />
            </SwiperSlide>
          ))}
        </Swiper>
      </div>
      {images.length > 3 && (
        <div className={s.controls}>
          <SliderNavigation onNext={onNext} onPrev={onPrev} {...params} />
        </div>
      )}
    </div>
  );
};
